import { apiRequest, ApiError } from './http';
import { getDeviceMeta } from '../helpers/device';
import type { ApiEnvelope, LoginResponse } from '../types/api';

// POST provision: zero-touch auto-login using the device's provisioning key.
// Returns the same shape as pairing/login when the key is bound to a paired
// device, or null when it isn't (server replies 404) so the caller falls back
// to the manual pairing screen.
export async function provisionDevice(provisioningKey: string): Promise<LoginResponse | null> {
  try {
    const res = await apiRequest<ApiEnvelope<LoginResponse>>('provision', {
      method: 'POST',
      body: { ...(await getDeviceMeta()), provisioning_key: provisioningKey },
      auth: false,
    });
    return res.data?.token ? res.data : null;
  } catch (e) {
    // 404 = key not provisioned yet; any other error = offline/transient.
    // Either way, fall back to pairing rather than blocking boot.
    if (e instanceof ApiError && e.status === 404) return null;
    return null;
  }
}
